import { getAuthenticationThunk } from '../registration/auth'
import { connectSocketIo } from '../../../socket'
import { setSocketConnecting, setSocketIoClient, setSocketReconnected } from '../../action/socket'
import { processPhoneMessageThunk } from '../../../socket/phone'
import { processPrinterMessageThunk } from '../../../socket/printer'
import { processCustomerMessageThunk } from '../../../socket/customer'
import { processRegistrationMessageThunk } from '../../../socket/registration'
import { processRestaurantMessageThunk } from '../../../socket/restaurant'
import { processOrderViewMessageThunk } from '../../../socket/order'
import { format } from 'date-fns'
import { processCashBookMessageThunk } from '../../../socket/cashbook'
import { processFiscalMessageThunk } from '../../../socket/fiscal'
import { processProductMessageThunk } from '../../../socket/product'
import { processPaymentMessageThunk } from '../../../socket/payment'
import { processKitchenMessageThunk } from '../../../socket/kitchen'
import { processWoltMessageThunk } from '../../../socket/wolt'
import { processTakeawayMessageThunk } from '../../../socket/takeaway'
import { processShopMessageThunk } from '../../../socket/shop'
import { processCashDeskMessageThunk } from '../../../socket/cashdesk'
import { processGeoDataMessageThunk } from '../../../socket/geodata'
import { logger } from '../../../logger/logger'
import { localStorageApi } from '../../../helper/localStorageApi'

export const connectSocketIoThunk = () => (dispatch, getState) => {
	if (!getState().socket.socketIoClient?.connected && !getState().socket.connecting) {
		dispatch(disconnectSocketThunk())
		dispatch(setSocketConnecting(true))
		logger.info('[socket-io] Try to connect socket')
		const accessToken = getState().core?.auth?.accessToken
		connectSocketIo(accessToken,
			socketIoClient => {
				dispatch(setSocketConnecting(false))
				dispatch(setSocketIoClient(socketIoClient))
			},
			() => dispatch(getAuthenticationThunk()),
			() => dispatch(setSocketReconnected(true)),
			message => {
				switch (message?.context) {
					case 'phone':
						dispatch(processPhoneMessageThunk(message))
						break
					case 'printer':
						dispatch(processPrinterMessageThunk(message))
						break
					case 'customer':
						dispatch(processCustomerMessageThunk(message))
						break
					case 'registration':
						dispatch(processRegistrationMessageThunk(message))
						break
					case 'restaurant':
						dispatch(processRestaurantMessageThunk(message))
						break
					case 'order-view':
						dispatch(processOrderViewMessageThunk(message))
						break
					case 'cashbook':
						dispatch(processCashBookMessageThunk(message))
						break
					case 'fiscal':
						dispatch(processFiscalMessageThunk(message))
						break
					case 'product':
						dispatch(processProductMessageThunk(message))
						break
					case 'payment':
						dispatch(processPaymentMessageThunk(message))
						break
					case 'kitchen':
						dispatch(processKitchenMessageThunk(message))
						break
					case 'wolt-plugin':
						dispatch(processWoltMessageThunk(message))
						break
					case 'takeaway-plugin':
						dispatch(processTakeawayMessageThunk(message))
						break
					case 'shop':
						dispatch(processShopMessageThunk(message))
						break
					case 'cashdesk':
						dispatch(processCashDeskMessageThunk(message))
						break
					case 'geodata':
						dispatch(processGeoDataMessageThunk(message))
						break
					default:
						logger.info('Unknown message context: ', message)
						break
				}
			})
	}
}

export const connectSocketClientMonitorIoThunk = () => (dispatch, getState) => {
	if (!getState().socket.socketIoClient?.connected) {
		logger.info(`Try to connect socket.io ... ${format(new Date(), 'HH:mm:ss')}`)
		const deviceId = localStorageApi.getItem('desktopDeviceId')
		const authUuid = localStorageApi.getItem('authUuid')

		connectSocketIo(null,
			socketIoClient => dispatch(setSocketIoClient(socketIoClient)),
			() => {},
			() => dispatch(setSocketReconnected(true)),
			message => {
				switch (message?.context) {
					case 'cashdesk':
						dispatch(processCashDeskMessageThunk(message))
						break
					default:
						logger.info('Unknown message context: ', message)
						break
				}
			}, true, deviceId, authUuid)
	}
}

export const disconnectSocketThunk = () => (dispatch, getState) => {
	let socketIoClient = getState().socket.socketIoClient
	if (socketIoClient) {
		logger.info('[socket-io] Called disconnect socket')
		socketIoClient.disconnect()
		dispatch(setSocketIoClient(null))
	}
}
